export default __webpack_public_path__ + "static/media/HessenForst.2eac8dcb.jpg";